export default function ( state=null, action ) {
    switch( action.type ) {
        case "UPDATE_ACTIVE_CARDS":
        return action.payload;


        default:
        return state;
    }
}